<script setup>
import { useForm } from "@/form";
import { PrimaryButton } from "@Components/Button";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t: __ } = useI18n();

const loaded = ref(false);
const newsBanners = ref([]);

const currentNewsBanner = computed(() => {
    if (newsBanners.value[0] !== undefined) {
        return newsBanners.value[0];
    }
});

const style = computed(() => {
    if (currentNewsBanner.value && currentNewsBanner.value.thumbnail_url) {
        return 'background-image: url("' + currentNewsBanner.value.thumbnail_url + '")';
    }
    return "";
});

onMounted(async () => {
    newsBanners.value = await useForm().post("news_banners_index");
    loaded.value = true;
});
</script>

<template>
    <div
        v-if="currentNewsBanner"
        :class="['h-60 w-full bg-gray-100 dark:bg-gray-900 bg-center bg-cover isolate rounded-lg overflow-hidden', !loaded ? 'animate-pulse' : '']"
        :style="style">
        <div class="h-full relative">
            <div v-if="currentNewsBanner.video_url" class="overflow-hidden absolute inset-0 z-0 flex justify-center items-center">
                <video class="min-w-full min-h-full" :src="currentNewsBanner.video_url" playsinline autoplay loop muted></video>
            </div>
            <div class="bg-opacity-30 absolute inset-0 z-10 bg-black"></div>
            <div :class="['max-w-2xl absolute inset-0 p-6 flex flex-col z-20']">
                <div class="flex-1">
                    <div v-if="currentNewsBanner.title" class="mb-1.5 text-4xl text-white" style="text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2)">
                        {{ currentNewsBanner.title }}
                    </div>
                    <div v-if="currentNewsBanner.description" class="text-lg leading-5 text-white" style="text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2)">
                        {{ currentNewsBanner.description }}
                    </div>
                </div>
                <div class="flex-none" v-if="currentNewsBanner.action_url">
                    <PrimaryButton as="a" :href="currentNewsBanner.action_url" target="_blank">{{
                        currentNewsBanner.action_title ?? "Continue"
                    }}</PrimaryButton>
                </div>
            </div>
        </div>
    </div>
</template>
